import DatePicker from "react-datepicker";
import { Controller, Control, FieldErrors } from "react-hook-form";
// import { ErrorMessage } from "@hookform/error-message";
import { ReactSVG } from "react-svg";
import "react-datepicker/dist/react-datepicker.css";
import { Label, FormGroup } from "reactstrap";
import DatepickerHeader from "./DatepickerHeader";
import IconCalendar from "../../../public/images/calendar_lines.svg";
import "../../datepicker.scss";
interface RHFDatepickerProps {
  name: string;
  defaultValue?: string | number | Date;
  className?: string;
  containerClassName?: string;
  formLabel?: string;
  minDate?: Date;
  format?: string;
  showTimeSelect?: boolean;
  showMonthYearPicker?: boolean;
  onInputChange?: (e: Date | null) => void;
  rules: object;
  errors: FieldErrors;
  control: Control;
  disabled?: boolean;
  placeholder?: string;
  maxDate?: Date;
}

const Datepicker = (props: RHFDatepickerProps) => {
  const {
    name,
    defaultValue,
    className = "",
    containerClassName,
    formLabel,
    onInputChange,
    showTimeSelect = false,
    showMonthYearPicker = false,
    minDate = null,
    maxDate = null,
    format = "dd/MM/yyyy",
    disabled = false,
    rules,
    control,
    errors,
    placeholder = "",
  } = props;

  return (
    <FormGroup
      className={`theme-form-input-container ${containerClassName || ""}`}
      style={{ marginBottom: "0",width:"100%" }}
    >
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue || ""}
        rules={rules || {}}
        render={({ field: { onChange, value } }) => (
          /* @ts-ignore */
          <DatePicker
            selected={value}
            disabled={disabled}
            dateFormat={format}
            showTimeSelect={showTimeSelect}
            minDate={minDate}
            maxDate={maxDate}
            useWeekdaysShort={true}
            showMonthYearPicker={showMonthYearPicker}
            placeholderText={placeholder}
            wrapperClassName="theme-custom-datepicker-wrapper"
            calendarClassName="theme-custom-datepicker"
            className={`theme-form-control ${className}`}
            renderCustomHeader={(props) => <DatepickerHeader {...props} />}
            onChange={(date: any) => {
              onChange(date);
              onInputChange && onInputChange(date);
            }}
          />
        )}
      />
    </FormGroup>
  );
};

export default Datepicker;
